import React from 'react';
import Button from "../../components/button/Button";
import Meta from "../../components/Meta";

const BookReview = () => {

  return (
    <section className="book-review pt-40">

      <Meta
        title="High Performance PostgreSQL for Rails"
        desc="Reliable, Scalable, Maintainable Database Applications"
        image="/images/books/high-performance-postgresql-for-rails.jpg"
        pageType="book"
        author="Andrew Atkinson"
      />

      <section className="relative">
        <div className="container ">
          <div className="justify-between lg:flex lg:space-x-20">
            <div className="min-w-fit">
              <img
                src="/images/books/high-performance-postgresql-for-rails.jpg"
                width="400"
                className="shadow-lg"
              />
              <div className="text-center mt-10">
                <Button title="Read with us" link="/pricing"/>
              </div>
            </div>
            <div className="lg:pr-25">
              <h1 className="font-display text-jacarta-700 text-4xl font-medium dark:text-white">
                High Performance PostgreSQL for Rails
              </h1>
              <h2 className="dark:text-jacarta-60 text-lg leading-normal mb-5">
                By <strong>Andrew Atkinson</strong>
              </h2>
              <p className="dark:text-jacarta-60 mb-5 leading-normal">
                Andrew Atkinson brings years of hands-on experience to this practical guide on
                getting the most out of PostgreSQL in Ruby on Rails applications. The book covers
                everything from query optimization and indexing strategies to connection pooling,
                partitioning, and database maintenance — all within the context of a Rails codebase.
              </p>
              <p className="dark:text-jacarta-60 mb-10 leading-normal">
                Even if you don't work with Rails, the PostgreSQL knowledge in this book is
                broadly applicable. You will learn how to identify slow queries, understand
                execution plans, and make informed decisions about schema design and scaling.
                A solid choice for backend engineers who want to go beyond the ORM and truly
                understand the database powering their applications.
              </p>

            </div>
          </div>
        </div>
      </section>

    </section>
  );
};

export default BookReview;
